import caretDown from 'assets/icons/arrow_light_down.svg';
import cx from 'classnames';
import { useEffect, useState } from 'react';
import SVG from 'react-inlinesvg';
import { Column } from 'ag-grid-community';
import { HeaderBackgroundColor, HeaderProps, Sort, TextColor } from './TableHeader.types';

const getColumnSort = (column?: Column): Sort | null => (column?.getSort() as Sort | undefined) ?? null;

export const TableHeader: React.FC<HeaderProps> = ({
  backgroundColor = HeaderBackgroundColor.PRIMARY,
  label,
  subLabel,
  sortable = false,
  textColor = TextColor.PRIMARY,
  justifyContent = 'justify-between px-2',
  disableContainerStyles = false,
  ...headerParams
}) => {
  const { column } = headerParams;
  const [activeSort, setActiveSort] = useState<Sort | null>(() => getColumnSort(column));

  useEffect(() => {
    if (!column) return undefined;

    const updateActiveSort = (): void => setActiveSort(getColumnSort(column));

    column.addEventListener('sortChanged', updateActiveSort);
    updateActiveSort();

    return () => column.removeEventListener('sortChanged', updateActiveSort);
  }, [column]);

  const handleSortColumn = (): void => {
    const sort = getColumnSort(column);

    if (sort === Sort.ASC) {
      headerParams.setSort(Sort.DESC);
    } else if (sort === Sort.DESC) {
      headerParams.setSort(null);
    } else {
      headerParams.setSort(Sort.ASC);
    }
  };

  return (
    <div
      className={cx('flex items-center w-full', justifyContent, {
        'py-1.5 text-neutral-950 rounded-sm m-[2px]': !disableContainerStyles,
        [backgroundColor]: !disableContainerStyles,
      })}
    >
      <div className="flex flex-col">
        <span className={cx('sub-header-sm', textColor)}>{label}</span>
        {subLabel && <div className={cx('sub-header-sm', textColor)}>{subLabel}</div>}
      </div>
      {sortable && (
        <button
          className="flex flex-col"
          onClick={handleSortColumn}
          type="button"
          data-dd-action-name={`Allocation report / Sort frame ID by ${
            activeSort === 'desc' ? 'Ascending' : 'Descending'
          } order`}
        >
          <SVG
            src={caretDown}
            className={cx('rotate-180 -mb-1 h-3 w-3', {
              'text-essential-tertiary': !activeSort || activeSort === Sort.DESC,
              'text-neutral-950': activeSort === Sort.ASC,
            })}
          />
          <SVG
            src={caretDown}
            className={cx('h-3 w-3', {
              'text-essential-tertiary': !activeSort || activeSort === Sort.ASC,
              'text-neutral-950': activeSort === Sort.DESC,
            })}
          />
        </button>
      )}
    </div>
  );
};
